<kendo-card class="card-container">
  <form [formGroup]="form" class="form">
    <kendo-gridlayout [rows]="[{height:40},{height:40},{height:275}]"
                      [cols]="[{width:150},{width:450}]"
                      [gap]="{rows:1, cols:40}">

      <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
        <kendo-label> Reason For Contact *</kendo-label>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
        <kendo-textbox formControlName="reasonForContact"></kendo-textbox>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item [row]="2" [col]="1" [colSpan]="1">
        <kendo-label> Order # (optional) </kendo-label>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [row]="2" [col]="2" [colSpan]="1">
        <kendo-textbox formControlName="orderNum"></kendo-textbox>
      </kendo-gridlayout-item>

      <kendo-gridlayout-item [row]="3" [col]="1" [colSpan]="1">
        <kendo-label>Message *</kendo-label>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [row]="3" [col]="2" [colSpan]="1">
        <kendo-textarea [rows]="10" formControlName="message"></kendo-textarea>
      </kendo-gridlayout-item>

    </kendo-gridlayout>
  </form>

  <button kendoButton class="btnSave" [disabled]="!form.valid || saving" (click)="save()">
    @if (saving){
    <kendo-loader type="pulsing" size="medium" themeColor="warning"></kendo-loader>
    } @else {
    <span id="iconContainer" style="display:block;float:left"><fa-icon #icon [icon]="saveIcon"></fa-icon></span>
    }
    &nbsp;&nbsp;
    Send
  </button>

</kendo-card>
